import { Stack } from '@chakra-ui/react';
import {
  RiContactsLine,
  RiDashboardLine,
  RiInputMethodLine,
  RiShieldUserLine,
  RiEqualizerLine,
  RiAncientGateLine,
  RiFlagLine,
  RiGitRepositoryPrivateLine,
  RiBookmarkLine,
  RiStackLine,
} from 'react-icons/ri';
import { useAuth } from '../../hooks/auth';
import { NavLink } from './NavLink';
import { NavSection } from './NavSection';

export const SidebarNav = (): JSX.Element => {
  const { user } = useAuth();

  return (
    <Stack spacing="12" align="flex-start" minWidth="170px">
      <NavSection title="Booking Management">
        {/* <NavLink icon={RiDashboardLine} to="/dashboard">
          Dashboard
        </NavLink> */}

        {user.featureGroup.features.some((feature) =>
          ['ACTIVITY_FULL_ACCESS', 'ACTIVITY_READ_ACCESS'].includes(
            feature.key,
          ),
        ) && (
          <NavLink icon={RiInputMethodLine} to="/activities">
            Calendars
          </NavLink>
        )}

        {user.featureGroup.features.some((feature) =>
          ['BOOKING_FULL_ACCESS', 'BOOKING_READ_ACCESS'].includes(feature.key),
        ) && (
          <NavLink icon={RiBookmarkLine} to="/bookings">
            Bookings
          </NavLink>
        )}

        {/* {user.featureGroup.features.some((feature) =>
          ['BOOKING_QUEUE_FULL_ACCESS', 'BOOKING_QUEUE_READ_ACCESS'].includes(
            feature.key,
          ),
        ) && (
          <NavLink icon={RiStackLine} to="/booking-queues">
            Fila de Reservas
          </NavLink>
        )} */}
      </NavSection>

      {user.featureGroup.features.some((feature) =>
        [
          'USER_FULL_ACCESS',
          'USER_READ_ACCESS',
          'SPOT_FULL_ACCESS',
          'SPOT_READ_ACCESS',
          'VENTURE_FULL_ACCESS',
          'VENTURE_READ_ACCESS',
        ].includes(feature.key),
      ) && (
        <>
          <NavSection title="Administration">
            {user.featureGroup.features.some((feature) =>
              ['USER_FULL_ACCESS', 'USER_READ_ACCESS'].includes(feature.key),
            ) && (
              <>
                <NavLink icon={RiContactsLine} to="/users">
                  Tenant users
                </NavLink>

                <NavLink icon={RiShieldUserLine} to="/members">
                  Members
                </NavLink>
              </>
            )}

            {user.featureGroup.features.some((feature) =>
              ['SPOT_FULL_ACCESS', 'SPOT_READ_ACCESS'].includes(feature.key),
            ) && (
              <NavLink icon={RiFlagLine} to="/spots">
                Resouces
              </NavLink>
            )}

            {user.featureGroup.features.some((feature) =>
              ['VENTURE_FULL_ACCESS', 'VENTURE_READ_ACCESS'].includes(
                feature.key,
              ),
            ) && (
              <NavLink icon={RiAncientGateLine} to="/ventures">
                Tenants
              </NavLink>
            )}
          </NavSection>
        </>
      )}

      {/* {user.featureGroup.features.some((feature) =>
        [
          'FEATURE_GROUP_FULL_ACCESS',
          'FEATURE_GROUP_READ_ACCESS',
          'FEATURE_FULL_ACCESS',
          'FEATURE_READ_ACCESS',
        ].includes(feature.key),
      ) && (
        <NavSection title="Configurações">
          {user.featureGroup.features.some((feature) =>
            ['FEATURE_GROUP_FULL_ACCESS', 'FEATURE_GROUP_READ_ACCESS'].includes(
              feature.key,
            ),
          ) && (
            <NavLink icon={RiEqualizerLine} to="/feature-groups">
              Grupos de permissões
            </NavLink>
          )}

          {user.featureGroup.features.some((feature) =>
            ['FEATURE_FULL_ACCESS', 'FEATURE_READ_ACCESS'].includes(
              feature.key,
            ),
          ) && (
            <NavLink icon={RiGitRepositoryPrivateLine} to="/features">
              Permissões
            </NavLink>
          )}
        </NavSection>
      )} */}
    </Stack>
  );
};
